import { useMemo, type ReactElement } from 'react'
import { CheckboxFilterMenu } from '@/components/ui/CheckboxFilterMenu'

export interface PoolChannelsMenuOption {
  slug: string
  label: string
}

export interface PoolChannelsMenuProps {
  /** O item "Pool do canal" do seletor; vira o gatilho do menu. */
  children: ReactElement
  poolName: string
  /** Os canais do pool, e o próprio pool (os vídeos ainda livres). */
  options: readonly PoolChannelsMenuOption[]
  /** Slugs desmarcados; vazio = todos marcados. */
  hidden: readonly string[]
  onHiddenChange: (hidden: string[]) => void
}

/**
 * Menu que abre ao passar o mouse sobre "Pool do canal": um checkbox por
 * canal do pool, todos marcados de início. É o ``CheckboxFilterMenu`` com o
 * título do pool; o clique no item continua escolhendo a visão.
 */
export function PoolChannelsMenu({ children, poolName, options, hidden, onHiddenChange }: PoolChannelsMenuProps) {
  const menuOptions = useMemo(() => options.map((o) => ({ value: o.slug, label: o.label })), [options])
  return (
    <CheckboxFilterMenu
      title={(shown, total) => `Pool ${poolName} · ${shown} de ${total}`}
      options={menuOptions}
      hidden={hidden}
      onHiddenChange={onHiddenChange}
    >
      {children}
    </CheckboxFilterMenu>
  )
}
